export default __webpack_public_path__ + "static/media/8EAA2280-60D0-4515-A572-59A8E98825B6_1_105_c.0681317d.jpeg";